import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { Icon } from "./icon";
import styles from "./styles.scss";

const initialSort = {
  isNameAscending: false,
  isNameDescending: false,
  isStatusAscending: false,
  isStatusDescending: false,
  isEndDateAscending: false,
  isEndDateDescending: false,
};

function Sort({ sort, setSort }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.sort}>
      <div
        className={styles.row}
        onClick={() =>
          setSort(
            sort.isNameAscending
              ? {
                  ...initialSort,
                  isNameDescending: true,
                  isNameAscending: false,
                }
              : sort.isNameDescending
                ? {
                    ...initialSort,
                    isNameDescending: false,
                    isNameAscending: false,
                  }
                : {
                    ...initialSort,
                    isNameDescending: false,
                    isNameAscending: true,
                  },
          )
        }
      >
        <p className={styles.text}>{"✔"}</p>
        <p className={styles.text}>{t("personalSynthesis.sort.name")}</p>
        <Icon
          className={styles.icon}
          isAscending={sort.isNameAscending}
          isDescending={sort.isNameDescending}
        />
      </div>
      <div
        className={styles.row}
        onClick={() =>
          setSort(
            sort.isStatusAscending
              ? {
                  ...initialSort,
                  isStatusDescending: true,
                  isStatusAscending: false,
                }
              : sort.isStatusDescending
                ? {
                    ...initialSort,
                    isStatusDescending: false,
                    isStatusAscending: false,
                  }
                : {
                    ...initialSort,
                    isStatusDescending: false,
                    isStatusAscending: true,
                  },
          )
        }
      >
        <p className={styles.text}>{t("personalSynthesis.sort.status")}</p>
        <Icon
          className={styles.icon}
          isAscending={sort.isStatusAscending}
          isDescending={sort.isStatusDescending}
        />
      </div>
      <div
        className={styles.row}
        onClick={() =>
          setSort(
            sort.isEndDateAscending
              ? {
                  ...initialSort,
                  isEndDateDescending: true,
                  isEndDateAscending: false,
                }
              : sort.isEndDateDescending
                ? {
                    ...initialSort,
                    isEndDateDescending: false,
                    isEndDateAscending: false,
                  }
                : {
                    ...initialSort,
                    isEndDateDescending: false,
                    isEndDateAscending: true,
                  },
          )
        }
      >
        <p className={styles.text}>{t("personalSynthesis.sort.date")}</p>
        <Icon
          className={styles.icon}
          isAscending={sort.isEndDateAscending}
          isDescending={sort.isEndDateDescending}
        />
      </div>
    </div>
  );
}

export { Sort };
